
import {mapState} from 'vuex';
import {generateCategoryUrl} from '~/plugins/helpers/catalog';

export default {
  name: 'TagList',
  props: {
    list: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: '',
    },
    routeGenerator: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState('route', {
      categoryCode: (state) => state.params.category || '',
      entityCode: (state) => state.params.entityCode,
    }),
  },
  methods: {
    routeCatalogWithoutFilters(tag) {
      const { entityCode, categoryCode } = this;
      const query = { ...this.$route.query };

      return {
        path: generateCategoryUrl('catalog', entityCode, categoryCode, tag),
        query,
      }
    },
  },
}
